// (function () {
//   if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
//     return;
//   }

//   gsap.registerPlugin(ScrollTrigger);

//   function splitHeadingWords(element) {
//     if (!element) {
//       return [];
//     }

//     if (element.dataset.wordsSplit === 'true') {
//       return element.querySelectorAll('.Athletes_video_scroll_heading_word');
//     }

//     const text = element.textContent.trim();
//     if (!text) {
//       return [];
//     }

//     const words = text.split(/\s+/);
//     element.textContent = '';

//     words.forEach((word, index) => {
//       const wordSpan = document.createElement('span');
//       wordSpan.className = 'Athletes_video_scroll_heading_word';
//       wordSpan.textContent = word;
//       element.appendChild(wordSpan);

//       if (index < words.length - 1) {
//         element.appendChild(document.createTextNode(' '));
//       }
//     });

//     element.dataset.wordsSplit = 'true';

//     return element.querySelectorAll('.Athletes_video_scroll_heading_word');
//   }

//   function initVideoScroll(section) {
//     if (!section) return;

//     const track = section.querySelector('[data-track]');
//     if (!track) return;

//     const pin = section.querySelector('.Athletes_video_scroll_pin');
//     const cards = track.querySelectorAll('.Athletes_video_scroll_card');
//     const popup = section.querySelector('[data-video-popup]');
//     const popupContent = section.querySelector('[data-popup-content]');
//     const heading = section.querySelector('[data-heading]');
//     const headingWords = heading
//       ? splitHeadingWords(heading)
//       : [];

//     if (!cards.length) return;

//     // -------------------------
//     // Body Scroll Lock
//     // -------------------------

//     function lockBody() {
//       const scrollbarWidth =
//         window.innerWidth -
//         document.documentElement.clientWidth;

//       document.body.style.setProperty(
//         '--scrollbar-width',
//         `${scrollbarWidth}px`
//       );

//       document.body.classList.add('overflow-hidden');
//     }

//     function unlockBody() {
//       document.body.classList.remove('overflow-hidden');
//       document.body.style.removeProperty('--scrollbar-width');
//     }

//     // -------------------------
//     // Horizontal Scroll
//     // -------------------------

//     const EXTRA_SCROLL_START = 250;

//     const getScrollAmount = () => {
//       return Math.max(
//         0,
//         track.scrollWidth - pin.clientWidth
//       );
//     };

//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: section,
//         start: 'top top',
//         end: () => '+=' + (getScrollAmount() + EXTRA_SCROLL_START),
//         pin: true,
//         scrub: 1,
//         invalidateOnRefresh: true,

//         onUpdate: (self) => {
//           const texts = section.querySelectorAll(
//             '.Athletes_video_scroll_description, .Athletes_video_scroll_eyebrow'
//           );

//           if (self.progress > 0.08) {
//             section.classList.add('is-dark');
//           } else {
//             section.classList.remove('is-dark');

//             gsap.set(texts, {
//               clearProps: 'color'
//             });

//             if (headingWords.length) {
//               gsap.set(headingWords, {
//                 color: '#000000'
//               });
//             }
//           }
//         }
//       }
//     });

//     // Pause before movement starts

//     tl.to({}, {
//       duration: 0.2
//     });

//     // Horizontal movement

//     tl.to(track, {
//       x: () => -getScrollAmount(),
//       ease: 'none',
//       duration: 0.8
//     });

//     if (headingWords.length) {
//       tl.set(
//         headingWords,
//         {
//           color: '#000'
//         },
//         0.08
//       );

//       headingWords.forEach((word, index) => {
//         tl.to(
//           word,
//           {
//             color: '#ffffff',
//             duration: 0.045,
//             ease: 'none'
//           },
//           0.32 + index * 0.1
//         );
//       });
//     }

//     // Fade Text White
//     // -------------------------

//     gsap.to(
//       section.querySelectorAll(
//         '.Athletes_video_scroll_description, .Athletes_video_scroll_eyebrow'
//       ),
//       {
//         color: '#ffffff',
//         ease: 'none',
//         scrollTrigger: {
//           trigger: section,
//           start: 'top top',
//           end: '+=400',
//           scrub: true
//         }
//       }
//     );

//     // -------------------------
//     // Video Popup
//     // -------------------------

//     section.querySelectorAll('[data-video-card]').forEach((card) => {
//       const playButton = card.querySelector(
//         '.Athletes_video_scroll_play'
//       );

//       if (!playButton) return;

//       playButton.addEventListener('click', () => {
//         const type = card.dataset.videoType;
//         const url = card.dataset.videoUrl;

//         if (!url) return;

//         popup.classList.add('active');
//         lockBody();

//         if (type === 'shopify') {
//           popupContent.innerHTML = `
//             <video
//               controls
//               autoplay
//               playsinline
//             >
//               <source src="${url}" type="video/mp4">
//             </video>
//           `;
//         }

//         if (type === 'embed') {
//           let embedHTML = '';

//           if (
//             url.includes('youtube.com') ||
//             url.includes('youtu.be')
//           ) {
//             const videoId = getYoutubeId(url);

//             embedHTML = `
//               <iframe
//                 src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0"
//                 allow="autoplay; encrypted-media"
//                 allowfullscreen>
//               </iframe>
//             `;
//           }

//           if (url.includes('vimeo.com')) {
//             const videoId = url.split('/').pop();

//             embedHTML = `
//               <iframe
//                 src="https://player.vimeo.com/video/${videoId}?autoplay=1"
//                 allow="autoplay; fullscreen"
//                 allowfullscreen>
//               </iframe>
//             `;
//           }

//           popupContent.innerHTML = embedHTML;
//         }
//       });
//     });

//     // -------------------------
//     // Close Popup
//     // -------------------------

//     section
//       .querySelectorAll('[data-close-popup]')
//       .forEach((button) => {
//         button.addEventListener('click', closePopup);
//       });

//     function closePopup() {
//       popup.classList.remove('active');
//       unlockBody();
//       popupContent.innerHTML = '';
//     }

//     document.addEventListener('keydown', (event) => {
//       if (event.key === 'Escape') {
//         closePopup();
//       }
//     });
//   }

//   // -------------------------
//   // YouTube Helper
//   // -------------------------

//   function getYoutubeId(url) {
//     const regExp =
//       /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?v=))([^#&?]*).*/;

//     const match = url.match(regExp);

//     return match && match[7].length === 11
//       ? match[7]
//       : '';
//   }

//   // -------------------------
//   // Init
//   // -------------------------

//   function init() {
//     document
//       .querySelectorAll('[data-athletes-video-scroll]')
//       .forEach(initVideoScroll);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   document.addEventListener(
//     'shopify:section:load',
//     function (event) {
//       const section = event.target.querySelector(
//         '[data-athletes-video-scroll]'
//       );

//       if (section) {
//         initVideoScroll(section);
//       }
//     }
//   );
// })();

(function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // -----------------------------------
  // Split heading into word spans
  // -----------------------------------
  function splitHeadingWords(element) {
    if (!element) return [];

    if (element.dataset.wordsSplit === 'true') {
      return element.querySelectorAll('.Athletes_video_scroll_heading_word');
    }

    const text = element.textContent.trim();
    if (!text) return [];

    const words = text.split(/\s+/);
    element.textContent = '';

    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.className = 'Athletes_video_scroll_heading_word';
      span.textContent = word;
      element.appendChild(span);

      // keep spaces between words
      if (index < words.length - 1) {
        element.appendChild(document.createTextNode(' '));
      }
    });

    element.dataset.wordsSplit = 'true';
    return element.querySelectorAll('.Athletes_video_scroll_heading_word');
  }

  function initVideoScroll(section) {
    if (!section || section.dataset.videoScrollInit === 'true') return;

    const track = section.querySelector('[data-track]');
    if (!track) return;

    const pin = section.querySelector('.Athletes_video_scroll_pin');
    const cards = track.querySelectorAll('.Athletes_video_scroll_card');
    const popup = section.querySelector('[data-video-popup]');
    const popupContent = section.querySelector('[data-popup-content]');
    const heading = section.querySelector('[data-heading]');
    const headingWords = heading ? splitHeadingWords(heading) : [];

    if (!cards.length || !pin) return;

    section.dataset.videoScrollInit = 'true';

    // -----------------------------------
    // Body Scroll Lock
    // -----------------------------------
    function lockBody() {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.setProperty(
        '--scrollbar-width',
        `${scrollbarWidth}px`
      );

      document.body.classList.add('overflow-hidden');
    }

    function unlockBody() {
      document.body.classList.remove('overflow-hidden');
      document.body.style.removeProperty('--scrollbar-width');
    }

    // -----------------------------------
    // Horizontal Scroll Setup
    // -----------------------------------
    const EXTRA_SCROLL_START = 250;
    const WORD_FILL_DURATION = 0.18;
    const WORD_STAGGER = 0.2;
    const INTRO_HOLD = 0.2;
    // Unfilled (faint) -> filled, mirroring the .agilitas-title fill animation.
    // Matches --color-grey-dark so it reads on both the light and dark section bg.
    const WORD_UNFILLED_COLOR = '#545454';
    const WORD_FILLED_COLOR = '#ffffff';

    const getScrollAmount = () => {
      return Math.max(0, track.scrollWidth - pin.clientWidth);
    };

    // Set initial heading word color (faint / unfilled)
    if (headingWords.length) {
      gsap.set(headingWords, {
        color: WORD_UNFILLED_COLOR
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: () => '+=' + (getScrollAmount() + EXTRA_SCROLL_START),
        pin: true,
        scrub: 1,
        invalidateOnRefresh: true,

        onUpdate: (self) => {
          const texts = section.querySelectorAll(
            '.Athletes_video_scroll_description, .Athletes_video_scroll_eyebrow'
          );

          if (self.progress > 0.08) {
            section.classList.add('is-dark');
          } else {
            section.classList.remove('is-dark');

            gsap.set(texts, {
              clearProps: 'color'
            });

            // reset heading words back to faint when scrolled to top
            if (headingWords.length) {
              gsap.set(headingWords, {
                color: WORD_UNFILLED_COLOR
              });
            }
          }
        }
      }
    });

    // -----------------------------------
    // Timeline
    // -----------------------------------

    // Small pause at top
    tl.to({}, { duration: INTRO_HOLD });

    // Horizontal track movement starts
    tl.to(
      track,
      {
        x: () => -getScrollAmount(),
        ease: 'none',
        duration: 1
      },
      INTRO_HOLD
    );

    // Fill heading words one by one while track is moving
    if (headingWords.length) {
      headingWords.forEach((word, index) => {
        tl.to(
          word,
          {
            color: WORD_FILLED_COLOR,
            duration: WORD_FILL_DURATION,
            ease: 'none'
          },
          INTRO_HOLD + 0.1 + index * WORD_STAGGER
        );
      });
    }

    // -----------------------------------
    // Fade text white while section darkens
    // -----------------------------------
    gsap.to(
      section.querySelectorAll(
        '.Athletes_video_scroll_description, .Athletes_video_scroll_eyebrow'
      ),
      {
        color: '#ffffff',
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: '+=400',
          scrub: true
        }
      }
    );

    // -----------------------------------
    // Video Popup
    // -----------------------------------
    section.querySelectorAll('[data-video-card]').forEach((card) => {
      // The whole card is clickable to play. The play button still works since
      // its click bubbles up to this same handler.
      card.addEventListener('click', () => {
        const type = card.dataset.videoType;
        const url = card.dataset.videoUrl;

        if (!url || !popup || !popupContent) return;

        popup.classList.add('active');
        lockBody();

        if (type === 'shopify') {
          popupContent.innerHTML = `
            <video controls autoplay playsinline>
              <source src="${url}" type="video/mp4">
            </video>
          `;
        }

        if (type === 'embed') {
          let embedHTML = '';

          if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const videoId = getYoutubeId(url);

            if (videoId) {
              embedHTML = `
                <iframe
                  src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen>
                </iframe>
              `;
            }
          }

          if (url.includes('vimeo.com')) {
            const videoId = url.split('/').pop();

            if (videoId) {
              embedHTML = `
                <iframe
                  src="https://player.vimeo.com/video/${videoId}?autoplay=1"
                  allow="autoplay; fullscreen"
                  allowfullscreen>
                </iframe>
              `;
            }
          }

          popupContent.innerHTML = embedHTML;
        }
      });
    });

    // -----------------------------------
    // Close Popup
    // -----------------------------------
    function closePopup() {
      if (!popup || !popupContent) return;
      popup.classList.remove('active');
      unlockBody();
      popupContent.innerHTML = '';
    }

    section.querySelectorAll('[data-close-popup]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePopup();
      }
    });
  }

  // -----------------------------------
  // YouTube Helper
  // -----------------------------------
  function getYoutubeId(url) {
    const regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?v=))([^#&?]*).*/;

    const match = url.match(regExp);

    return match && match[7] && match[7].length === 11 ? match[7] : '';
  }

  // -----------------------------------
  // Init
  // -----------------------------------
  function init() {
    document
      .querySelectorAll('[data-athletes-video-scroll]')
      .forEach(initVideoScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-athletes-video-scroll]');
    if (section) {
      initVideoScroll(section);
    }
  });
})();
